/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
import React from "react";
import { components } from "react-select";
import { Tooltip } from "../../../../../components";

export default function CustomOption(props) {
	if (props.isDisabled) {
		return (
			<Tooltip
				content={global.lang.t(
					"This location has not been approved by your Agency, please contact an admin for approval",
				)}
				placement="top"
			>
				<div>
					<components.Option {...props} />
				</div>
			</Tooltip>
		);
	}

	return <components.Option {...props} />;
}
